import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./AiraloOffers.css";
import monkeyLogo from "../assets/Monito 512 x 512.png";

function AiraloOffers() {
  const [offers, setOffers] = useState([]);
  const [loadingOffers, setLoadingOffers] = useState(true);
  const [devices, setDevices] = useState([]);
  const [loadingDevices, setLoadingDevices] = useState(true);
  const [selectedDevice, setSelectedDevice] = useState("");
  const [searchDevice, setSearchDevice] = useState("");
  const [highlightIndex, setHighlightIndex] = useState(-1);
  const [customerEmail, setCustomerEmail] = useState("");
  const [promoCode, setPromoCode] = useState("");
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [showCoverage, setShowCoverage] = useState({});
  const [vendedor, setVendedor] = useState(null);

  useEffect(() => {
    const idv = localStorage.getItem('id_vendedor');
    const nombre = localStorage.getItem('nombre');
    if (idv && idv !== 'undefined' && idv !== 'null') {
      setVendedor({ id: idv, nombre: nombre || '' });
    }
  }, []);

  // Fallback de cobertura por tipo de plan
  const COVERAGE_FALLBACK = {
    global: [
      "Estados Unidos", "Canadá", "México", "Brasil", "Argentina", "Colombia", "Chile",
      "Reino Unido", "Francia", "Alemania", "España", "Italia", "Países Bajos", "Suiza", "Portugal",
      "Japón", "Corea del Sur", "China", "India", "Tailandia", "Singapur", "Australia",
      "Turquía", "Emiratos Árabes", "Sudáfrica", "Egipto", "Israel", "Nueva Zelanda",
      "y 170+ países más"
    ],
    europa: [
      "España", "Francia", "Alemania", "Italia", "Portugal", "Países Bajos", "Bélgica",
      "Suiza", "Austria", "Grecia", "Irlanda", "Reino Unido", "Suecia", "Noruega",
      "Dinamarca", "Finlandia", "Polonia", "República Checa", "Hungría", "Croacia",
      "Rumania", "Bulgaria", "Eslovaquia", "Eslovenia", "Estonia", "Letonia", "Lituania",
      "Luxemburgo", "Malta", "Chipre", "Islandia"
    ],
    americas: [
      "Estados Unidos", "Canadá", "México", "Brasil", "Argentina", "Colombia", "Chile",
      "Perú", "Ecuador", "Costa Rica", "Panamá", "República Dominicana", "Puerto Rico",
      "Uruguay", "Paraguay", "Bolivia", "Guatemala", "Honduras", "El Salvador", "Nicaragua"
    ],
    asia: [
      "Japón", "Corea del Sur", "China", "Tailandia", "Singapur", "Malasia", "Indonesia",
      "Vietnam", "Filipinas", "India", "Taiwán", "Hong Kong", "Macao", "Camboya", "Laos",
      "Myanmar", "Sri Lanka", "Bangladesh", "Nepal", "Pakistán"
    ]
  };

  const getFallbackCoverage = (pkg) => {
    const id = (pkg.package_id || pkg.title || "").toLowerCase();
    if (id.includes("europ") || id.includes("eurolink")) return COVERAGE_FALLBACK.europa;
    if (id.includes("america") || id.includes("latam")) return COVERAGE_FALLBACK.americas;
    if (id.includes("asia")) return COVERAGE_FALLBACK.asia;
    return COVERAGE_FALLBACK.global;
  };

  // Intenta obtener cobertura dinámica del backend, si falla usa fallback
  const fetchCoverageForPackages = async (packages) => {
    return Promise.all(
      packages.map(async (pkg) => {
        if (pkg.coverage && pkg.coverage.length > 0) return pkg;
        try {
          const res = await fetch(
            "https://l0sqt7a9v0.execute-api.us-east-1.amazonaws.com/prod/airalo_coverage",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ package_id: pkg.package_id }),
            }
          );
          const data = await res.json();
          const cov = data.body?.coverage || data.coverage;
          if (Array.isArray(cov) && cov.length > 0) return { ...pkg, coverage: cov };
        } catch { /* fallback */ }
        return { ...pkg, coverage: getFallbackCoverage(pkg) };
      })
    );
  };

  const getFormattedTitle = (pkg) => {
    if (pkg.title && pkg.title.trim() !== "") return pkg.title;
    const id = pkg.package_id?.toLowerCase() || "";
    if (id.includes("discover")) return "Discover Global";
    if (id.includes("eurolink")) return "Eurolink Europa";
    if (id.includes("global")) return "Plan Global";
    return "Plan Internacional";
  };

  const formatCurrency = (value, locale, currency) => {
    if (typeof value !== "number" || isNaN(value)) return "N/D";
    try {
      return value.toLocaleString(locale, { style: "currency", currency });
    } catch {
      return `${value} ${currency}`;
    }
  };

  useEffect(() => {
    fetch("https://l0sqt7a9v0.execute-api.us-east-1.amazonaws.com/prod/getdisp", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({}),
    })
      .then((res) => res.json())
      .then((result) => {
        let list = [];
        if (Array.isArray(result.body?.data)) {
          list = result.body.data.map(
            (d) => d.name || d.device_name || d.title || d.toString()
          );
        }
        setDevices(list);
        setLoadingDevices(false);
      })
      .catch((err) => {
        console.error("Error al cargar dispositivos:", err);
        toast.error("Error al cargar dispositivos");
        setLoadingDevices(false);
      });
  }, []);

  useEffect(() => {
    fetch("https://l0sqt7a9v0.execute-api.us-east-1.amazonaws.com/prod/airalo", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ country: "EU" }),
    })
      .then((res) => res.json())
      .then((data) => {
        const paquetes = typeof data.body === "string" ? JSON.parse(data.body) : data.body;
        const formatted = Array.isArray(paquetes)
          ? paquetes.map((pkg) => ({
              ...pkg,
              title: getFormattedTitle(pkg),
              price_mxn: Number(pkg.price_mxn) || 0,
            }))
          : [];
        // Enriquecer con cobertura dinámica o fallback
        fetchCoverageForPackages(formatted).then((enriched) => {
          setOffers(enriched);
          setLoadingOffers(false);
        });
      })
      .catch((err) => {
        console.error("Error al cargar ofertas:", err);
        toast.error("Error al cargar ofertas");
        setLoadingOffers(false);
      });
  }, []);

  const handleBuy = async (pkg) => {
    if (!customerEmail) {
      toast.error("Por favor ingresa tu email antes de continuar.");
      return;
    }

    // Si hay código promocional, validar y registrar comisión
    if (promoCode) {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const valRes = await fetch(`${apiUrl}/prod/ec2proxy`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ method: 'GET', path: `/validar_codigo?c=${promoCode}` }),
        });
        const valData = await valRes.json();
        const val = typeof valData.body === 'string' ? JSON.parse(valData.body) : valData.body || valData;

        if (val.valid && val.vendedor) {
          const comPct = parseFloat(val.vendedor.comision_pct) || 10;
          const comMonto = (pkg.price_mxn * comPct / 100).toFixed(2);
          // Registrar comisión
          await fetch(`${apiUrl}/prod/ec2proxy`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ method: 'POST', path: '/comisiones', data: {
              codigo_vendedor: promoCode,
              id_vendedor: val.vendedor.id_vendedor,
              nombre_vendedor: val.vendedor.nombre,
              cliente_email: customerEmail,
              paquete: pkg.title,
              precio: pkg.price_mxn,
              comision_pct: comPct,
              comision_monto: comMonto,
            }}),
          });
        }
      } catch (e) { console.error('Error registrando comisión:', e); }
    }

    const payload = { ...pkg, email: customerEmail, promoCode: promoCode || null };
    fetch("https://l0sqt7a9v0.execute-api.us-east-1.amazonaws.com/prod/genera_pago_airalo", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.body?.checkout_url) window.location.href = data.body.checkout_url;
        else toast.error("No se pudo generar el link de pago.");
      })
      .catch(() => toast.error("Error al procesar la compra"));
  };

  const filteredDevices = devices
    .filter((d) => d.toLowerCase().includes(searchDevice.toLowerCase()))
    .slice(0, 10);

  const handleKeyDown = (e) => {
    if (!filteredDevices.length) return;
    if (e.key === "ArrowDown") setHighlightIndex((p) => (p + 1) % filteredDevices.length);
    else if (e.key === "ArrowUp") setHighlightIndex((p) => (p - 1 + filteredDevices.length) % filteredDevices.length);
    else if (e.key === "Enter" && highlightIndex >= 0) {
      setSelectedDevice(filteredDevices[highlightIndex]);
      setSearchDevice("");
      setHighlightIndex(-1);
    }
  };

  const toggleCoverage = (id, e) => {
    if (e) e.stopPropagation();
    setShowCoverage((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  if (loadingDevices || loadingOffers) return <div className="airalo-loading">Cargando ofertas...</div>;

  return (
    <div className="airalo-page">
      <ToastContainer />

      {/* VENDEDOR BAR */}
      {vendedor && (
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          padding: '10px 16px', background: '#fff', borderRadius: '12px',
          marginBottom: '12px', border: '1px solid #d4e8d6', fontSize: '13px',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontSize: '16px' }}>👤</span>
            <div>
              <div style={{ fontWeight: 700, color: '#1a3a2a' }}>{vendedor.nombre}</div>
              <div style={{ fontSize: 11, color: '#6b8f71' }}>ID: {vendedor.id}</div>
            </div>
          </div>
        </div>
      )}

      {/* HERO */}
      <div className="airalo-hero">
        <img src={monkeyLogo} alt="MonkeyPhone" className="airalo-hero-img" />
        <span className="airalo-hero-badge">eSIM Digital</span>
        <h1>Viaja conectado al mundo entero</h1>
        <p>
          Compra tu eSIM internacional y navega en más de 200 destinos.
          Sin cambiar de chip, sin roaming, sin complicaciones.
        </p>
        <div className="airalo-trust">
          <div className="trust-item">🌍 +200 destinos</div>
          <div className="trust-item">⚡ Activa en minutos</div>
          <div className="trust-item">💰 Sin cargos ocultos</div>
        </div>
      </div>

      {/* CÓMO FUNCIONA */}
      <div className="airalo-steps">
        <h2 className="airalo-steps-title">¿Cómo funciona?</h2>
        <div className="airalo-steps-grid">
          <div className="airalo-step-card">
            <div className="airalo-step-icon">📱</div>
            <h3>1. Verifica tu dispositivo</h3>
            <p>Busca tu modelo para confirmar que es compatible con eSIM.</p>
          </div>
          <div className="airalo-step-card">
            <div className="airalo-step-icon">🛒</div>
            <h3>2. Elige tu plan</h3>
            <p>Selecciona el paquete de datos ideal para tu viaje.</p>
          </div>
          <div className="airalo-step-card">
            <div className="airalo-step-icon">✈️</div>
            <h3>3. Conéctate y viaja</h3>
            <p>Recibe tu eSIM por correo, instálala y listo.</p>
          </div>
        </div>
      </div>

      {/* Buscador de dispositivos */}
      <div className="airalo-search">
        <input
          type="text"
          className="airalo-search-input"
          placeholder="🔍 Escribe el nombre de tu móvil..."
          value={searchDevice}
          onChange={(e) => { setSearchDevice(e.target.value); setHighlightIndex(-1); }}
          onKeyDown={handleKeyDown}
        />
        {searchDevice && filteredDevices.length > 0 && (
          <div className="airalo-dropdown">
            {filteredDevices.map((d, idx) => (
              <div
                key={idx}
                className={`airalo-dropdown-item ${highlightIndex === idx ? "highlighted" : ""}`}
                onMouseEnter={() => setHighlightIndex(idx)}
                onClick={() => { setSelectedDevice(d); setSearchDevice(""); setHighlightIndex(-1); }}
              >
                {d}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Grid de ofertas */}
      <div className="airalo-grid">
        {offers.map((pkg, idx) => (
          <div key={idx} className="airalo-card" onClick={() => setSelectedOffer(pkg)}>
            <h3>{pkg.title}</h3>
            <p className="airalo-card-detail">📶 {pkg.datos_amount || "N/A"} de datos</p>
            <p className="airalo-card-detail">⏱ {pkg.vality || "N/A"}</p>
            <p className="airalo-card-price">{formatCurrency(pkg.price_mxn, "es-MX", "MXN")}</p>
            {pkg.descripcion && <p className="airalo-card-desc">{pkg.descripcion}</p>}

            {pkg.coverage && pkg.coverage.length > 0 && (
              <>
                <button
                  className={`coverage-btn ${showCoverage[pkg.package_id] ? "active" : ""}`}
                  onClick={(e) => toggleCoverage(pkg.package_id, e)}
                >
                  {showCoverage[pkg.package_id] ? "Ocultar cobertura" : "Ver cobertura"}
                </button>
                {showCoverage[pkg.package_id] && (
                  <ul className="coverage-list">
                    {pkg.coverage.map((c, i) => <li key={i}>{c}</li>)}
                  </ul>
                )}
              </>
            )}

            <button className="airalo-card-buy" onClick={(e) => { e.stopPropagation(); setSelectedOffer(pkg); }}>
              Comprar
            </button>
          </div>
        ))}
      </div>

      {/* Modal de compra */}
      {selectedOffer && (
        <div className="airalo-overlay" onClick={() => setSelectedOffer(null)}>
          <div className="airalo-modal" onClick={(e) => e.stopPropagation()}>
            <h3>Comprar {selectedOffer.title}</h3>
            <p className="airalo-modal-price">
              {formatCurrency(selectedOffer.price_mxn, "es-MX", "MXN")}
              {selectedOffer.price_usd ? ` (${formatCurrency(selectedOffer.price_usd, "en-US", "USD")})` : ""}
            </p>

            {selectedOffer.coverage && selectedOffer.coverage.length > 0 && (
              <>
                <button
                  className={`coverage-btn ${showCoverage[selectedOffer.package_id] ? "active" : ""}`}
                  onClick={() => toggleCoverage(selectedOffer.package_id)}
                >
                  {showCoverage[selectedOffer.package_id] ? "Ocultar cobertura" : "Ver cobertura"}
                </button>
                {showCoverage[selectedOffer.package_id] && (
                  <ul className="coverage-list">
                    {selectedOffer.coverage.map((c, i) => <li key={i}>{c}</li>)}
                  </ul>
                )}
              </>
            )}

            <input
              type="email"
              className="airalo-modal-input"
              placeholder="Tu correo electrónico"
              value={customerEmail}
              onChange={(e) => setCustomerEmail(e.target.value)}
              required
            />
            <input
              type="text"
              className="airalo-modal-input"
              placeholder="Código promocional (opcional)"
              value={promoCode}
              onChange={(e) => setPromoCode(e.target.value)}
            />

            <div className="airalo-modal-actions">
              <button className="airalo-btn-cancel" onClick={() => setSelectedOffer(null)}>Cancelar</button>
              <button className="airalo-btn-buy" onClick={() => handleBuy(selectedOffer)}>Comprar ahora</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AiraloOffers;
